/**
 * Issue-type option lists for the dashboard's pickers and filters, derived
 * from the shared vocabulary (@overlayqa/shared, 2026-09-02). Before, four
 * hand-typed lists (IssueDrawer, TicketDetailsCard, TicketsPage, IssuesPage)
 * each said "Design Gap" and offered A11y to humans; none knew design-token.
 */
import { ISSUE_TYPES, PICKABLE_ISSUE_TYPES } from '@overlayqa/shared';

export interface IssueTypeOption {
  value: string;
  label: string;
}

/** What a human may choose: Bug / Mismatch / Improvement / General. */
export const ISSUE_TYPE_PICKER_OPTIONS: IssueTypeOption[] = PICKABLE_ISSUE_TYPES.map((t) => ({
  value: t.value,
  label: t.label,
}));

/** What a filter may match: every type, machine-stamped included. */
export const ISSUE_TYPE_FILTER_OPTIONS: IssueTypeOption[] = ISSUE_TYPES.map((t) => ({
  value: t.value,
  label: t.label,
}));

/**
 * Severity and status, in the order the issue detail card offers them
 * (TicketDetailsCard.tsx). Here rather than hand-typed at each picker for the
 * same reason the type lists moved here in 2026-09-02: the issues table now
 * offers all three in place too, and a third hand-typed copy is a third thing
 * to forget. Neither vocabulary lives in @overlayqa/shared yet, so these read
 * as the dashboard's own until one does.
 */
export const ISSUE_SEVERITY_OPTIONS: IssueTypeOption[] = [
  { value: 'critical', label: 'Critical' },
  { value: 'high', label: 'High' },
  { value: 'medium', label: 'Medium' },
  { value: 'low', label: 'Low' },
];

export const ISSUE_STATUS_OPTIONS: IssueTypeOption[] = [
  { value: 'open', label: 'Open' },
  { value: 'in-progress', label: 'In Progress' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'verified', label: 'Verified' },
  { value: 'closed', label: 'Closed' },
];
